
<template>
  <Modal
    :value="visible"
    :title="$t('pages_deduct_coupon_index_447')"
    :footer-hide="true"
    :width="700"
    @on-cancel="toggle"
  >
    <TablePaginate
      :columns="columns"
      :data="products"
      :loading="loading"
      :meta="meta"
      :onSelectionChange="onSelectionChange"
      :changePage="changePage"
    ></TablePaginate>

    <Button
      type="primary"
      size="large"
      style="width: 150px; margin-top: 10px"
      @click="onSubmit"
      >{{ $t("pages_combo_index_284") }}</Button
    >
  </Modal>
</template>

<script>
import i18n from "../../../locales/index";
import { mapActions, mapMutations, mapGetters } from "vuex";
import TablePaginate from "@/components/TablePaginate";
import { tableAvatar } from "@/libs/table-render";
export default {
  name: "EditMaterialModal",
  props: ["visible"],
  components: { TablePaginate },
  data() {
    return {
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center",
        },
        {
          title: i18n.t("pages_ai_thirdparty_165"),
          key: "image",

          width: 200,
          align: "center",
          render: (h, params) => {
            return tableAvatar(h, params.row.image);
          },
        },
        {
          title: i18n.t("pages_ai_image_158"),
          key: "name",
          width: 200,
          align: "center",
        },
        {
          title: i18n.t("pages_ai_thirdparty_166"),
          key: "lingshoujia",
          width: 100,
          align: "center",
        },
        {
          title: i18n.t("pages_ai_thirdparty_167"),
          key: "huiyuanjia",
          width: 100,
          align: "center",
        },
      ],
      product_ids:[]
    };
  },
  created() {
    this.resetQuery();
    this.productIndex({ is_display: "ignore" });
  },
  computed: {
    ...mapGetters("product", ["products", "loading", "meta"]),
  },
  methods: {
    ...mapMutations("product", ["changeQuery", "resetQuery"]),
    ...mapActions("product", {
      productIndex: "index",
    }),
    changePage(page) {
      this.changeQuery({ page: page });
      this.productIndex({ is_display: "ignore" });
    },
    onSubmit() {
      this.$emit("submit", this.product_ids);
    },
    toggle() {
      this.$emit("toggle");
    },
    onSelectionChange(e) {
      this.product_ids = e.map(value=>{
        return value.id
      }) 
    },
  }
};
</script>

<style lang="scss" scoped>
.editMaterialModal {
  button {
    display: block;
    margin: 30px auto 0;
  }
}
</style>
